<template>
  <MarketReportCard
    :title="$t('market_insights.consulting_services.title')"
    :description="$t('market_insights.consulting_services.description')"
    icon="fa-solid fa-user-tie"
    action-icon="fa-solid fa-comment"
    :action-text="$t('market_insights.consulting_services.button_text')"
    @open:report="handleContactUs"
  />
</template>

<script setup lang="ts">
import { useHelpCrunch } from "@/composables/useHelpCrunch";
import MarketReportCard from "./MarketReportCard.vue";

const { openHelpCrunch } = useHelpCrunch();

const handleContactUs = openHelpCrunch;
</script>
